/* global mixpanel */
/**
 * Created by alvinoktavianus on 10/10/17
 */

export function libraryPromoStart () {
  mixpanel.track('Promo Start')
}

export function libraryPromoCreate (newPromoData) {
  mixpanel.track('Promo Create', newPromoData)
}

export function libraryPromoUpdate ({promoName, appliesMultiple, haveTimePeriod, assignedOutlet}) {
  mixpanel.track('Promo Update', {
    'Promo Name': promoName,
    'Promo Configuration': {
      'Applies in Multiple': appliesMultiple,
      'Time Period': haveTimePeriod,
      'Assigned Outlet': assignedOutlet
    }
  })
}

export function libraryPromoDeleteReactivateDeactivate (eventName, {promoType, promoName, outlet}) {
  mixpanel.track(eventName, {
    'Promo Type': promoType,
    'Promo Name': promoName,
    'Outlet Name': outlet
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/promo.js